import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of, pipe } from 'rxjs';
import { BaseService } from "@app/cp/shared/services/base.service";
import { LDFlagValue } from "launchdarkly-js-client-sdk";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService extends BaseService {

    //Launch Darkly Docs: https://docs.launchdarkly.com/sdk/client-side/javascript#getting-started
    private _featureFlagSets: any = {};
    private _featureFlagSetsSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public featureFlagSets = this._featureFlagSetsSubject.asObservable();
    constructor(_http: HttpClient) {
        super(_http);
        this.onInit();
    }

    /**
     * This should only be used from within base classes to bridge scenarios where RXJS reactivity is not possible. Components should NOT use this ever.
     *
     * @readonly
     * @type {{}}
     * @memberof FeatureFlagService
     */
    get latestFeatureFlagSet(): {} {
        return this._featureFlagSets;
    }

    onInit() {
        this.receiveAllFlags();
    }

    private updateSingleFlag(data: any) {
        Object.keys(data).forEach((flag: string) => {
            this._featureFlagSets[flag] = data[flag].current;
        });
        this.broadcastFlags();
    }

    private broadcastFlags() {
        this._featureFlagSetsSubject.next(this._featureFlagSets);
    }

    evaluateFlag(flag: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.rootUrl_v2 + 'Utility/ld/ui/flag/' + flag;
        return this._http.get(url_call, { headers: headers });
    }

    allFlags(): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.rootUrl_v2 + 'Utility/ld/ui/flag/all';
        return this._http.get(url_call, { headers: headers });
    }

    public receiveAllFlags() {
        this.allFlags().subscribe({
            next: (result): LDFlagValue => {
                this._featureFlagSets = result;
                this.broadcastFlags();
            },
            error: (err) => {
                this._featureFlagSets = {};
                this.broadcastFlags();
                console.log('error', err);
            }
        });
    }

    /**
     * This is used in the FeatureFlagResolver to ensure the flags are loaded before the route is navigated to
     *
     * @return {*}  {Observable<boolean>}
     * @memberof FeatureFlagService
     */
    public receiveAllFlagsAsObservable(): Observable<boolean> {
        return this.allFlags().pipe(
            map((data) => {
                this._featureFlagSets = data;
                this.broadcastFlags();
                return true;
            }),
            catchError(e => {
                this._featureFlagSets = {};
                this.broadcastFlags();
                console.log('error', e);
                return of(false);
            }));
    }

    public LdIsFeatureEnabled(flag: string) {
        this.evaluateFlag(flag).subscribe({
            next: (result) => {
                let set = {
                    flag: result,
                };
                this.updateSingleFlag(set);
                return result;
            },
            error: (err) => {
                console.log('error', err);
            }
        });
    };
}
